// extracted by mini-css-extract-plugin
module.exports = {"con":"style_con__3Y5GK","bgImage":"style_bgImage__gZALA"};